// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LViG","option":"styles_option__1C4tN","active":"styles_active__2fZA0"};